import {signal} from "@preact/signals-react";

export const bannersDetailsIsEmpty = signal(false)
export const bannersDetailsHasLimit = signal(false)

export const resetBannersDetailsSignals = () => {
    bannersDetailsIsEmpty.value = false
    bannersDetailsHasLimit.value = false
}
